module.exports = __webpack_public_path__ + "img/chev-right-white.1a90caf7.svg";